import cn from 'classnames';
import { Button, Grid } from 'ht-styleguide';
import CustomerReviews from 'src/components/UI/Reviews';
import { Review } from 'types/reviews.types';
import { RefReference } from 'types/base.types';
import { smoothScroll } from '../locationPage.utils';
import styles from '../locationPage.module.scss';

type ReviewsProps = {
  reviews: Review[];
  cityName: string;
  reviewsRef: RefReference<HTMLDivElement>;
};

const ReviewsBlock = ({ reviews, cityName, reviewsRef }: ReviewsProps) => (
  <Grid.Fluid>
    <CustomerReviews
      dynamicRef={reviewsRef}
      reviews={reviews}
      className={styles.review}
      carouselItemStyle={styles.reviewItem}
      headerStyles="text-align-center paddingBottom-medium"
      headerText={`${cityName} Loves HelloTech`}
      suppressAddressLine
    />
    <Grid.Row classes="text-align-center">
      <Grid.Column smOffset={1} sm={2} mdOffset={3} md={2} lgOffset={5} lg={2}>
        <Button huge onClick={smoothScroll} className={cn('marginBottom-huge', styles.button)}>
          Get a Price
        </Button>
      </Grid.Column>
    </Grid.Row>
  </Grid.Fluid>
);

export default ReviewsBlock;
